import React, { useEffect, useState } from 'react';
import { cn } from '../../lib/utils';

export const Panel = ({ title, sub, right, children, className, testid }) => (
  <section className={cn('gpj-panel', className)} data-testid={testid}>
    {(title || right) && (
      <div className="gpj-panel-h">
        <div>{title && <h2>{title}</h2>}{sub && <p>{sub}</p>}</div>
        {right}
      </div>
    )}
    {children}
  </section>
);

export const Section = ({ eyebrow, title, lead, right, testid }) => (
  <div className="egt-intro" data-testid={testid}>
    <div>
      <div className="egt-eyebrow">{eyebrow}</div>
      <h1 className="egt-h1">{title}</h1>
      {lead && <p className="egt-lead">{lead}</p>}
    </div>
    {right}
  </div>
);

export const Sub = ({ children, note, right }) => (
  <div className="egt-sec">
    <div><h2><i />{children}</h2>{note && <p style={{ marginTop: 4 }}>{note}</p>}</div>
    {right}
  </div>
);

export const Tile = ({ label, value, sub, src, tone, delay = 0, testid }) => (
  <div className="egt-tile" style={{ animation: `gpfIn .6s var(--ease) ${delay}ms both` }} data-testid={testid}>
    {src && <span className={cn('egt-src', src.toLowerCase())}>{src}</span>}
    <small>{label}</small>
    <strong className={tone}>{value}</strong>
    {sub && <em>{sub}</em>}
  </div>
);

export const Slider = ({ label, value, min, max, step = 1, fmt, onChange, tone, testid }) => {
  const p = ((value - min) / (max - min)) * 100;
  return (
    <div className="egt-ctrl">
      <label>{label}<b>{fmt ? fmt(value) : value}</b></label>
      <input type="range" className="egt-range" min={min} max={max} step={step} value={value} onChange={(e) => onChange(parseFloat(e.target.value))} style={{ '--p': `${p}%`, '--tone': tone }} data-testid={testid} />
    </div>
  );
};

export const NumInput = ({ label, value, onChange, min = 0, testid }) => {
  const [txt, setTxt] = useState(String(value));
  const [focus, setFocus] = useState(false);
  useEffect(() => { if (!focus) setTxt(String(value)); }, [value, focus]);
  const commit = (raw) => { const v = parseFloat(raw); if (Number.isFinite(v) && v >= min) onChange(v); };
  return (
    <div className="egt-ctrl">
      <label>{label}</label>
      <input type="number" min={min} className="egt-num" value={focus ? txt : String(value)} onFocus={() => { setFocus(true); setTxt(String(value)); }} onBlur={() => { setFocus(false); const v = parseFloat(txt); onChange(Number.isFinite(v) ? Math.max(min, v) : value); }} onChange={(e) => { setTxt(e.target.value); commit(e.target.value); }} data-testid={testid} />
    </div>
  );
};

export const Badge = ({ tone = 'grey', children }) => <span className={cn('gpj-badge', `gpj-b-${tone}`)}>{children}</span>;

export const PRI_TONE = { high: 'red', medium: 'amber', low: 'grey' };
export const STATUS_LABEL = { not_started: ['grey', 'Not started'], in_progress: ['blue', 'In progress'], at_risk: ['amber', 'At risk'], completed: ['green', 'Completed'] };
